import * as o from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/Rows.es.js";
const e = o.forwardRef((r, s) => /* @__PURE__ */ o.createElement(t, { ref: s, ...r, weights: a }));
e.displayName = "RowsIcon";
const n = e;
export {
  n as Rows,
  e as RowsIcon
};
